import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import settings from '../settings.json';

const apiHost = process.env.REACT_APP_API_HOST;
const apiProto = process.env.REACT_APP_API_PROTOCOL;

class VolcanoPlotTable extends React.Component {
  handleClick = () => {
    const { category, results } = this.props;
    const payload = {
      type: 'heatmap',
      genes: results,
      category,
    };

    let redirectBase = '/nuclei/heatmap';

    if (category === 'singlecell') {
      // payload and redirect url to go to single cell page
      redirectBase = '/single-cell/heatmap';
    } else {
      // payload and redirect url to go to nuclei page
      payload.ord = settings.regionList;
      payload.de_mode = 'both';
    }

    // submit values to the backend storage and retrieve the uuid
    axios.post(`${apiProto}://${apiHost}/search`, payload).then((response) => {
      // redirect to the results page which will load in the image and parameters.
      const redirect = `${redirectBase}/${response.data}`;
      this.props.history.push(redirect);
    });
  }

  render() {
    const { results } = this.props;
    return (
      <table className="table">
        <thead>
          <tr>
            <th>Top Genes</th>
            <th><button className="btn btn-primary" onClick={this.handleClick}>View as heatmap</button></th>
          </tr>
        </thead>
        <tbody>
          {results.map(n => (
            <tr key={n}>
              <td colSpan={2}>{n}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}

export default withRouter(VolcanoPlotTable);

VolcanoPlotTable.propTypes = {
  results: PropTypes.array.isRequired,
  history: PropTypes.object.isRequired,
  category: PropTypes.string,
};

VolcanoPlotTable.defaultProps = {
  category: 'singlecell',
};



// WEBPACK FOOTER //
// ./src/components/VolcanoPlotTable.jsx